<template>
  <div>
    <tabs centered type="neutral" position="bottom" tab-nav-wrapper-classes="card-header-nav icon" tab-content-classes="tab-content-padding tab-no-space " v-model="activeTab">

      <tab-pane label="home">
        <template slot="label">
          <i class="fas fa-ambulance" @click="
                    $store.commit('setState', {
                      stateName: 'homePageActiveTab',
                      stateValue: 'home',
                    })
                  "></i>
        </template>
        <div style="height: calc(100vh - 198px); overflow: scroll; width: 100%;">
          <div class="row" v-if="ambulanceRequest &&  ambulanceRequest.latestStatus && ambulanceRequest.latestStatus=='Assigned'">
            <div class="col-12">
              <card class="card-stats">
                <div class="statistics statistics-horizontal">
                  <div class="info info-horizontal">
                    <div class="row visit-details details">
                      <div class="col-4">
                        <div class="row">
                          <div class="col-12">
                            <img src="@/assets/img/proAvatar.png" class="picture-src" style="width:100px; border-radius: 50%; outline-color: transparent;" />
                            <br />
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-12">
                            <div v-if="ambulanceRequest && ambulanceRequest.patient && ambulanceRequest.patient.gender == 'male'" style="color:rgb(33, 150, 243);">
                              <span>
                                <i style="margin-left: 42px;" class="fa fa-mars"></i>
                              </span>
                            </div>
                            <div v-if="ambulanceRequest && ambulanceRequest.patient && ambulanceRequest.patient.gender == 'female'" style="color:rgb(235, 63, 157);">
                              <span>
                                <i style="margin-left: 42px;" class="fa fa-venus"></i>
                              </span>
                            </div>
                            <div v-if="ambulanceRequest && ambulanceRequest.patient && ambulanceRequest.patient.gender == 'others'" style="color:rgb(33, 243, 208);">
                              <span>
                                <i style="margin-left: 42px;" class="fa fa-transgender-alt"></i>
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-8">
                        <slot>
                          <div class="row">
                            <div class="col-md-1 col-3 text-center">
                              <span>
                                <i class="fa fa-user"></i>
                              </span>
                            </div>
                            <div class="col-md-8 col-9 pl-0">
                              <span>{{ambulanceRequest.patient.firstName}} {{ ambulanceRequest.patient.lastName }}</span>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-md-1 col-3 text-center">
                              <span>
                                <i class="fa fa-info-circle"></i>
                              </span>
                            </div>
                            <div class="col-md-10 col-9 pl-0">
                              <span>{{ambulanceRequest.patient.patientId}}</span>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-md-1 col-3 text-center">
                              <span>
                                <i class="fa fa-birthday-cake"></i>
                              </span>
                            </div>
                            <div class="col-md-8 col-9 pl-0">
                              <span>{{ getAge(ambulanceRequest.patient.dob)}}</span>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-md-1 col-3 text-center">
                              <span>
                                <i class="fa fa-mobile"></i>
                              </span>
                            </div>
                            <div class="col-md-8 col-9 pl-0">
                              <a :href="`tel:${ambulanceRequest.patient.mobileNumber}`">{{ ambulanceRequest.patient.mobileNumber}}</a>
                            </div>
                          </div>
                        </slot>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="stats" slot="footer">
                  <div class="row">
                    <div class="col-4" style="text-align: left;">
                      <span style="font-weight: bold;">Patient's Location:</span>
                    </div>
                    <div class="col-8" style="text-align: left;">
                      <span>{{ambulanceRequest.location.source.address}}</span>
                    </div>
                  </div>
                  <hr>
                  <div class="row">
                    <div class="col-4" style="text-align: left;">
                      <span style="font-weight: bold;">Destination Location:</span>
                    </div>
                    <div class="col-8" style="text-align: left;">
                      <span>{{ambulanceRequest.location.destination.address}}</span>
                    </div>
                  </div>
                  <n-button type="primary" style="margin-top: 1em;" class="btn-padding mr-2" round @click.native="acceptAmbulanceRequest()">
                    <i slot="label" class="now-ui-icons arrows-1_minimal-right"></i>
                    Accept
                  </n-button>
                  <n-button type="secondary" style="margin-top: 1em;" class="btn-padding mr-2" round @click.native="declineAmbulanceRequest()">
                    <i slot="label" class="now-ui-icons ui-1_simple-remove"></i>
                    Decline
                  </n-button>
                </div>
              </card>
            </div>
          </div>
          <div class="row" style="margin-bottom: 1em;width: 100%;" v-if="!ambulanceRequest || !ambulanceRequest.latestStatus">
            <div class="col-12 text-center" style="margin-top: 1em;">
              <h6><i>{{ $t("message.No request for you at the moment") }}</i></h6>
              <img src="@/assets/img/ambulance.svg" class="ambulance-image" />
            </div>
          </div>
          <div class="row" v-if="ambulanceRequest && ambulanceRequest.latestStatus && ambulanceRequest.latestStatus != 'Assigned'">
            <div class="col-12">
              <card class="card-stats">
                <div class="statistics statistics-horizontal">
                  <div class="info info-horizontal">
                    <div class="row visit-details details">
                      <div class="col-4">
                        <div class="row">
                          <div class="col-12">
                            <img src="@/assets/img/proAvatar.png" class="picture-src" style="width:100px; border-radius: 50%; outline-color: transparent;" />
                            <br />
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-12">
                            <div v-if="ambulanceRequest && ambulanceRequest.patient && ambulanceRequest.patient.gender == 'male'" style="color:rgb(33, 150, 243);">
                              <span>
                                <i style="margin-left: 42px;" class="fa fa-mars"></i>
                              </span>
                            </div>
                            <div v-if="ambulanceRequest && ambulanceRequest.patient && ambulanceRequest.patient.gender == 'female'" style="color:rgb(235, 63, 157);">
                              <span>
                                <i style="margin-left: 42px;" class="fa fa-venus"></i>
                              </span>
                            </div>
                            <div v-if="ambulanceRequest && ambulanceRequest.patient && ambulanceRequest.patient.gender == 'others'" style="color:rgb(33, 243, 208);">
                              <span>
                                <i style="margin-left: 42px;" class="fa fa-transgender-alt"></i>
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-8">
                        <slot>
                          <div class="row">
                            <div class="col-md-1 col-3 text-center">
                              <span>
                                <i class="fa fa-user"></i>
                              </span>
                            </div>
                            <div class="col-md-8 col-9 pl-0">
                              <span v-if="ambulanceRequest && ambulanceRequest.patient">{{ambulanceRequest.patient.firstName}} {{ ambulanceRequest.patient.lastName }}</span>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-md-1 col-3 text-center">
                              <span>
                                <i class="fa fa-info-circle"></i>
                              </span>
                            </div>
                            <div class="col-md-10 col-9 pl-0">
                              <span v-if="ambulanceRequest && ambulanceRequest.patient">{{ambulanceRequest.patient.patientId}}</span>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-md-1 col-3 text-center">
                              <span>
                                <i class="fa fa-birthday-cake"></i>
                              </span>
                            </div>
                            <div class="col-md-8 col-9 pl-0">
                              <span v-if="ambulanceRequest && ambulanceRequest.patient">{{ getAge(ambulanceRequest.patient.dob)}}</span>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-md-1 col-3 text-center">
                              <span>
                                <i class="fa fa-mobile"></i>
                              </span>
                            </div>
                            <div class="col-md-8 col-9 pl-0">
                              <a :href="`tel:${ambulanceRequest.patient.mobileNumber}`">{{ ambulanceRequest.patient.mobileNumber}}</a>
                            </div>
                          </div>
                        </slot>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="stats" slot="footer">
                  <div class="row">
                    <div class="col-4" style="text-align: left;">
                      <span style="font-weight: bold;">{{ $t("message.Patient's Location:") }}</span>
                    </div>
                    <div class="col-8" style="text-align: left;">
                      <span v-if="ambulanceRequest && ambulanceRequest.location && ambulanceRequest.location.source && ambulanceRequest.location.source.address">{{ambulanceRequest.location.source.address}}</span>
                    </div>
                    <div class="col-12" style="text-align: center;margin-top:0.5em;" v-if="ambulanceRequest && ambulanceRequest.latestStatus == 'Accepted'">
                      <n-button type="primary" class="btn-padding mr-2" round @click.native="openLocationInMaps(ambulanceRequest.location.source)">
                        <span style="display: flex;align-items: flex-start;">
                          <i class="fas fa-map-marked"></i><span> {{ $t("message.Navigate") }}</span>
                        </span>
                      </n-button>
                    </div>
                  </div>
                  <hr>
                  <div class="row">
                    <div class="col-4" style="text-align: left;">
                      <span style="font-weight: bold;"> {{ $t("message.Destination Location:") }}</span>
                    </div>
                    <div class="col-8" style="text-align: left;">
                      <span v-if="ambulanceRequest && ambulanceRequest.location && ambulanceRequest.location.destination && ambulanceRequest.location.destination.address">{{ambulanceRequest.location.destination.address}}</span>
                    </div>
                    <div class="col-12" style="text-align: center;margin-top:0.5em;" v-if="ambulanceRequest && ambulanceRequest.latestStatus == 'OnBoarded'">
                      <n-button type="primary" class="btn-padding mr-2" round @click.native="openLocationInMaps(ambulanceRequest.location.destination)">
                        <span style="display: flex;align-items: flex-start;">
                          <i class="fas fa-map-marked"></i><span>{{ $t("message.Navigate") }}</span>
                        </span>
                      </n-button>
                    </div>
                  </div>
                  <hr>
                  <div class="row">
                    <div class="col-4" style="text-align: left;">
                      <span style="font-weight: bold;">{{ $t("message.Status:") }}</span>
                    </div>
                    <div class="col-8" style="text-align: left;" v-if="ambulanceRequest.latestStatus == 'OnBoarded'">
                      {{ $t("message.Onboarded") }}
                    </div>
                    <div class="col-8" style="text-align: left;" v-else>
                      <span>{{ambulanceRequest.latestStatus}}</span>
                    </div>
                  </div>
                  <n-button v-if="ambulanceRequest && ambulanceRequest.latestStatus == 'Accepted'" style="margin-top:1em;" type="primary" class="btn-padding mr-2" round @click.native="onBoardPatient()">
                    {{ $t("message.Patient onboarded") }}
                  </n-button>
                  <n-button v-if="ambulanceRequest && ambulanceRequest.latestStatus == 'OnBoarded'" style="margin-top:1em;" type="primary" class="btn-padding mr-2" round @click.native="dropPatient()">
                    {{ $t("message.Patient dropped") }}
                  </n-button>
                </div>
              </card>
            </div>
          </div>
        </div>
      </tab-pane>

      <tab-pane label="videoCall" v-if="showVideo">
        <template slot="label">
          <i class="fas fa-video" @click="
                    $store.commit('setState', {
                      stateName: 'homePageActiveTab',
                      stateValue: 'videoCall',
                    })
                  "></i>
        </template>
        <div class="fullscreen-window">
          <vmaatu :query="simpleMeetingsQuery" ref="vmaatu"></vmaatu>
          <n-button type='danger' size="md" class="end-button" @click.native="endCall()">
            <i class="fas fa-phone-slash"></i>
            {{ $t("message.End") }}
          </n-button>
        </div>
      </tab-pane>

    </tabs>

    <call-notification v-if="callNotification" :caller="caller" :callType="'incoming'" @call-declined="onCallDeclined()" @call-accepted="onCallAccepted()" @call-missed="onCallMissed()">
    </call-notification>

    <modal :show.sync="showBluetoothListModel" headerClasses="justify-content-center" :showClose="false">
      <h4 slot="header" class="title title-up">{{ $t("message.Paired Bluetooth Devices") }}</h4>
      <ul style="list-style: none; padding-left: 0px;">
        <li style="font-size: 1.2em; border-bottom: solid 1px lightgrey; line-height: 2.5em;" v-for="item in bluetoothDevicesList" :key="item.id" @click="connectToBluetoothDevice(item)">
          {{ item.name }}
        </li>
      </ul>
    </modal>
  </div>

</template>

<script>
/* eslint-disable no-undef */
/* eslint-disable no-console */
import { TabPane, Tabs, Collapse, CollapseItem, Modal } from "src/components";
import avatarImage from "@/assets/img/proAvatar.png";
import {
  StatsCard,
  Switch,
  TimeLine,
  TimeLineItem,
  Table as NTable,
  Checkbox,
} from "src/components";
import { DatePicker } from "element-ui";
import { CoolSelect } from "vue-cool-select";
import { Carousel, Slide } from "vue-carousel";
import Vmaatu from "../../../pages/simplemeetings/Vmaatu.vue";

import WebexTeams from "../../../pages/simplemeetings/WebexTeams.vue";

import swal from "sweetalert2";
import Message from "src/pages/carenation/Message.vue";
import socket from "@/services/socket";
import moment from "moment-timezone";
import CallNotification from "../../../components/CallNotification.vue";
import responsePIDS from "../../../services/obdInfo.js";

export default {
  name: "home",

  components: {
    TabPane,
    Tabs,
    Collapse,
    CollapseItem,
    StatsCard,
    [Switch.name]: Switch,
    TimeLine,
    TimeLineItem,
    CallNotification,
    NTable,
    Checkbox,
    [DatePicker.name]: DatePicker,
    Message,
    Modal,
    CoolSelect,
    Carousel,
    Slide,
    Vmaatu,
    WebexTeams,
  },

  data() {
    return {
      searchText: "",
      appointment: null,
      Authentication: {},
      currentPage: 0,
      cardName: null,
      cardDescription: null,
      careCoordinatorList: null,
      messageTextFilter: null,
      messageDateFilter: null,
      appointmentsDateFilter: new Date(),
      selectedMessage: null,
      APPT_REQUESTED: false,
      simpleMeetingsQuery: {},
      CREATE_NEW_MESSAGE: false,
      subject: null,
      selectedDoctor: null,
      doctorSearchText: "",
      filteredDoctorList: [],
      CARECO_JOINED: false,
      CARECARDS_LOADED: false,
      UNREAD_MESSAGE: true,
      unreadChatList: [],
      SHOW_VC: true,
      SHOW_MESSAGES_TAB: false,
      messages: [],
      filteredScheduledAppointments: [],
      SHOW_CARECO_DISCLAIMER: false,
      SHOW_DOCTOR_DISCLAIMER: false,
      workingHours: {},

      messagesPagination: {
        totalPages: 0,
        pageNumber: 1,
      },
      scheduledApptPagiantion: {
        totalPages: 0,
        pageNumber: 1,
      },
      doctorSearchString: null,

      nursegroup: null,
      requestedServices: [],
      caller: {},
      callNotification: false,
      incomingCallAppt: {},
      ambulanceRequest: null,
      remoteUser: {},
      showVideo: false,
      connstatus: "",
      btConnected: false,
      btConnecting: false,
      connectedBluetoothDeviceName: "",
      queue: [],
      init_queue: [],
      btIntervalWriter: 0,
      receivedData: "",
      bluetoothDevicesList: [],
      showBluetoothListModel: false,
      obd2Data: {},
      lastObd2UpdatedMinute: 0,
      lastObd2UpdatedMinuteInterval: null,
    };
  },

  computed: {
    user() {
      if (localStorage.user) {
        return JSON.parse(localStorage.user);
      }
    },
    FCMpayload() {
      return this.$store.state.FCMpayload;
    },
    settings() {
      return this.$store.state.settings;
    },
    locationTrackingEnabled() {
      return this.$store.state.locationTracking && BackgroundGeolocation;
    },
    activeTab() {
      return this.$store.state.homePageActiveTab;
    },
  },

  methods: {
    async init() {
      await this.$store.dispatch("getSettings");
      await this.$store.dispatch(
        "getCaregroup",
        this.user.caregroup._id || this.user.caregroup
      );

      if (this.user.nursegroup) {
        this.nursegroup = await this.$store.dispatch(
          "getNursegroup",
          this.user.nursegroup._id || this.user.nursegroup
        );
      }
    },
    initSocket() {
      //Join room with patient ID
      socket.emit("joinRoom", {
        type: "user",
        id: this.user._id,
        deviceToken: localStorage.firebaseToken,
      });

      socket.emit("joinRoom", {
        type: "other",
        id: this.user.patientId,
      });

      //Join room with endpoint name
      socket.emit("joinRoom", {
        type: "endpoint",
        id: this.user.endpoint.name,
      });

      //Join nursegroup room
      socket.emit("joinRoom", {
        type: "nursegroup",
        id: this.user.nursegroup,
        userId: this.user._id,
      });

      if (this.appointment && this.appointment._id) {
        //Join this appointment room
        socket.emit("joinRoom", {
          type: "appointment",
          id: this.appointment._id,
          userId: this.user._id,
        });
      }

      if (this.ambulanceRequest && this.ambulanceRequest._id) {
        socket.emit("joinRoom", {
          type: "ambulance",
          id: this.ambulanceRequest._id,
          userId: this.user._id,
        });
      }
    },
    async onBoardPatient() {
      swal
        .fire({
          type: "info",
          title: this.$t("message.Are you sure?"),
          showCancelButton: true,
          confirmButtonText: this.$t("message.Yes"),
          cancelButtonText: this.$t("message.No"),
        })
        .then(async (result) => {
          if (result && result.value) {
            let loader = this.$loading.show({
              container: null,
              canCancel: false,
            });
            try {
              let res = await this.$store.dispatch(
                "updateAmbulanceRequestStatus",
                {
                  ambulanceRequestId: this.ambulanceRequest._id,
                  status: "OnBoarded",
                  endpointName: this.user.endpoint.name,
                }
              );
              if (res) {
                this.ambulanceRequest = res;
                swal.fire({
                  text: this.$t("message.Status updated!"),
                  type: "success",
                  timer: 3000,
                });
                socket.emit("ambulanceRequestStatusUpdated", {
                  ambulanceRequestId: this.ambulanceRequest._id,
                  ambulacneEndpoint: this.user.endpoint.name,
                });
              }
              loader.hide();
            } catch (e) {
              loader.hide();
              swal.fire({
                text: this.$t("message.Couldn't update the status!"),
                type: "error",
                timer: 3000,
                title: this.$t("message.Error"),
              });
            }
          }
        });
    },
    async dropPatient() {
      swal
        .fire({
          type: "info",
          title: this.$t("message.Are you sure?"),
          showCancelButton: true,
          confirmButtonText: this.$t("message.Yes"),
          cancelButtonText: this.$t("message.No"),
        })
        .then(async (result) => {
          if (result && result.value) {
            let loader = this.$loading.show({
              container: null,
              canCancel: false,
            });
            try {
              let res = await this.$store.dispatch(
                "updateAmbulanceRequestStatus",
                {
                  ambulanceRequestId: this.ambulanceRequest._id,
                  status: "Dropped",
                  endpointName: this.user.endpoint.name,
                }
              );
              if (res) {
                swal.fire({
                  text: this.$t("message.Status updated!"),
                  type: "success",
                  timer: 3000,
                });
                socket.emit("ambulanceRequestStatusUpdated", {
                  ambulanceRequestId: this.ambulanceRequest._id,
                  ambulacneEndpoint: this.user.endpoint.name,
                });

                this.$store.commit("setState", {
                  stateName: "ambulanceRequest",
                  stateValue: this.ambulanceRequest,
                });

                this.ambulanceRequest = null;
                this.$router.push("ambulancefeedback");
              }
              loader.hide();
            } catch (e) {
              loader.hide();
              swal.fire({
                text: this.$t("message.Couldn't update the status!"),
                type: "error",
                timer: 3000,
                title: this.$t("message.Error"),
              });
            }
          }
        });
    },
    async acceptAmbulanceRequest() {
      let loader = this.$loading.show({
        container: null,
        canCancel: false,
      });
      try {
        let res = await this.$store.dispatch("updateAmbulanceRequestStatus", {
          ambulanceRequestId: this.ambulanceRequest._id,
          status: "Accepted",
          endpointName: this.user.endpoint.name,
        });
        if (res) {
          this.ambulanceRequest = res;
          socket.emit("joinRoom", {
            type: "ambulance",
            id: this.ambulanceRequest._id,
            userId: this.user._id,
          });
          swal.fire({
            text: this.$t("message.Ambulance request accepted!"),
            type: "success",
            timer: 3000,
          });
          socket.emit("ambulanceRequestStatusUpdated", {
            ambulanceRequestId: this.ambulanceRequest._id,
            ambulacneEndpoint: this.user.endpoint.name,
          });
        }
        loader.hide();
      } catch (e) {
        loader.hide();
        swal.fire({
          text: this.$t("message.Couldn't accept the request!"),
          type: "error",
          timer: 3000,
          title: this.$t("message.Error"),
        });
      }
    },
    async declineAmbulanceRequest() {
      swal
        .fire({
          type: "info",
          title: this.$t("message.Are you sure?"),
          showCancelButton: true,
          confirmButtonText: this.$t("message.Yes"),
          cancelButtonText: this.$t("message.No"),
        })
        .then(async (result) => {
          if (result && result.value) {
            let loader = this.$loading.show({
              container: null,
              canCancel: false,
            });
            try {
              let res = await this.$store.dispatch(
                "updateAmbulanceRequestStatus",
                {
                  ambulanceRequestId: this.ambulanceRequest._id,
                  status: "Declined",
                  endpointName: this.user.endpoint.name,
                }
              );
              if (res) {
                swal.fire({
                  text: this.$t("message.Ambulance request declined!"),
                  type: "success",
                  timer: 3000,
                });
                socket.emit("ambulanceRequestStatusUpdated", {
                  ambulanceRequestId: this.ambulanceRequest._id,
                  ambulacneEndpoint: this.user.endpoint.name,
                  status: "Declined",
                });
                this.ambulanceRequest = null;
              }
              loader.hide();
            } catch (e) {
              loader.hide();
              swal.fire({
                text: this.$t("message.Couldn't decline the request!"),
                type: "error",
                timer: 3000,
                title: this.$t("message.Error"),
              });
            }
          }
        });
    },
    openLocationInMaps(location) {
      let geocoords =
        location.geolocation.coordinates[1] +
        "," +
        location.geolocation.coordinates[0];

      if (device && device.platform == "iOS") {
        window.open("maps://?q=" + geocoords, "_system");
      } else {
        let label = encodeURI(location.address);
        window.open("geo:0,0?q=" + geocoords + "(" + label + ")", "_system");
      }
    },

    getAge(date) {
      var m = moment(date);
      var years = moment().diff(m, "years", false);
      var months = moment().diff(m.add(years, "years"), "months", false);
      return years + " years, " + months + " months";
    },
    async getAmbulanceRequest() {
      let that = this;
      try {
        this.ambulanceRequest = await this.$store.dispatch(
          "getAmbulanceRequest",
          this.user.endpoint.name
        );
        if (this.ambulanceRequest._id) {
          // let instance = this.baseUrl
          //   .split("//")[1]
          //   .split(":")[0]
          //   .replace(/\./g, "_");

          this.simpleMeetingsQuery = {
            api_key: this.settings.vMaatuSettings.apikey,
            room_name: this.instance + "_" + this.ambulanceRequest._id,
            user_name: this.user.username,
            tenant_name: this.user.tenant.name,
            controls: "true",
            video_encoding: this.ambulanceRequest.preferredVideoCodec || "",
          };

          if (this.ambulanceRequest.latestStatus != "Assigned") {
            socket.emit("joinRoom", {
              type: "ambulance",
              id: this.ambulanceRequest._id,
              userId: this.user._id,
            });
            for (
              let i = this.ambulanceRequest.chatMessages.length - 1;
              i >= 0;
              i--
            ) {
              if (
                this.ambulanceRequest.chatMessages[i].content &&
                this.ambulanceRequest.chatMessages[i].content == "Video call"
              ) {
                if (
                  this.ambulanceRequest.chatMessages[i].status == "initiated"
                ) {
                  this.remoteUser = this.ambulanceRequest.chatMessages[i].from;
                  this.caller.name = this.remoteUser.name;
                  this.caller.img = avatarImage;
                  this.callNotification = true;
                } else if (
                  this.ambulanceRequest.chatMessages[i].status == "accepted"
                ) {
                  this.remoteUser = this.ambulanceRequest.chatMessages[i].from;
                  this.showVideo = true;
                  setTimeout(() => {
                    that.$store.commit("setState", {
                      stateName: "homePageActiveTab",
                      stateValue: "videoCall",
                    });
                    that.$refs.vmaatu.init();
                  }, 1000);
                }
                break;
              }
            }
          }
        }
      } catch (e) {
        console.log(e);
      }
    },

    //Location tracking methods
    handleLocationtracking() {
      let that = this;
      BackgroundGeolocation.checkStatus(function (status) {
        console.log(
          "[INFO] BackgroundGeolocation service is running",
          status.isRunning
        );
        console.log(
          "[INFO] BackgroundGeolocation services enabled",
          status.locationServicesEnabled
        );
        console.log(
          "[INFO] BackgroundGeolocation auth status: " + status.authorization
        );

        if (!status.locationServicesEnabled) {
          swal
            .fire({
              title: that.$t("message.Location services disabled"),
              text: that.$t("message.Would you like to open location settings?"),
              type: "info",
              showCancelButton: true,
              confirmButtonColor: "#DD6B55",
              closeOnConfirm: true,
            })
            .then((confirm) => {
              if (confirm.value) {
                BackgroundGeolocation.showLocationSettings();
              }
              //that.init_bluetooth();
            });
        } else {
          //that.init_bluetooth();
        }

        if (!status.isRunning) {
          BackgroundGeolocation.start();
        }
      });
    },
    onCallMissed() {
      this.callNotification = false;
      socket.emit("leaveRoom", {
        type: "appointment",
        id: this.incomingCallAppt._id,
        userId: this.user._id,
      });
    },
    async onCallDeclined() {
      this.callNotification = false;
      let response = await this.$store.dispatch("updateAmbulanceCallStatus", {
        status: "declined",
        requestId: this.ambulanceRequest._id,
      });

      if (response && response._id) {
        this.ambulanceRequest.chatMessages = response.chatMessages;
        this.ambulanceRequest._v = response._v;

        let message = {
          username: this.user.username,
          status: "declined",
          to: this.remoteUser.username,
        };

        socket.emit("newChatMessage", {
          ambulanceRequestId: this.ambulanceRequest._id,
          chatMessage: message,
        });
      }
    },
    async onCallAccepted() {
      let that = this;
      this.callNotification = false;

      let response = await this.$store.dispatch("updateAmbulanceCallStatus", {
        status: "accepted",
        requestId: this.ambulanceRequest._id,
      });

      if (response && response._id) {
        this.ambulanceRequest.chatMessages = response.chatMessages;
        this.ambulanceRequest._v = response._v;

        this.showVideo = true;

        setTimeout(() => {
          that.$store.commit("setState", {
            stateName: "homePageActiveTab",
            stateValue: "videoCall",
          });
          that.$refs.vmaatu.init();
        }, 1000);
        let message = {
          username: this.user.username,
          status: "accepted",
          to: this.remoteUser.username,
        };
        socket.emit("newChatMessage", {
          ambulanceRequestId: this.ambulanceRequest._id,
          chatMessage: message,
        });
      }
    },
    endCall() {
      swal
        .fire({
          title: this.$t("message.Are you sure you want to end the call?"),
          confirmButtonText: this.$t("message.Yes"),
          showCancelButton: true,
          cancelButtonText: this.$t("message.No"),
        })
        .then(async (result) => {
          if (result && result.value) {
            if (this.$refs.vmaatu) {
              this.$refs.vmaatu.destroy();
            }
            this.showVideo = false;
            this.$store.commit("setState", {
              stateName: "homePageActiveTab",
              stateValue: "home",
            });

            let response = await this.$store.dispatch(
              "updateAmbulanceCallStatus",
              {
                status: "ended",
                requestId: this.ambulanceRequest._id,
              }
            );

            if (response && response._id) {
              this.ambulanceRequest.chatMessages = response.chatMessages;
              this.ambulanceRequest._v = response._v;

              let message = {
                username: this.user.username,
                status: "ended",
                to: this.remoteUser.username,
              };
              socket.emit("newChatMessage", {
                ambulanceRequestId: this.ambulanceRequest._id,
                chatMessage: message,
              });
            }
          }
        });
    },
  },

  async mounted() {
    let that = this;
    this.$root.onBackButton = () => {
      swal
        .fire({
          title: this.$t("message.Are you sure?"),
          confirmButtonText: this.$t("message.Exit"),
          showCancelButton: true,
          cancelButtonText: this.$t("message.Stay"),
        })
        .then(async (result) => {
          if (result && result.value) {
            BackgroundGeolocation.stop();
            navigator.app.exitApp();
          }
        });
    };

    window.onAppResume = () => {
      setTimeout(() => {
        //this.init();
        this.handleLocationtracking();
      }, 0);
    };

    /*     bluetoothSerial.list(
      (list) => {
        console.log("blue tooth list--", list);
      },
      (err) => {
        console.log(err);
      }
    );

    let address = "B0:35:9F:38:5D:0F";
    let devicename = "Linux";
    bluetoothSerial.connect(
      address,
      (success) => {
        this.btConnected = true;
        this.btIsConnecting = false;
        this.connstatus = "Connected";
        this.connectedBluetoothDeviceName = devicename;
        console.log("[INFO] " + this.connstatus);
        this.deviceConnected();
      },
      (error) => {
        this.connstatus = this.$t("message.Error");
        this.btIsConnecting = false;
        this.btConnected = false;
        console.log("[INFO] BT Conn. Status: " + this.connstatus);
      }
    ); */

    BackgroundGeolocation.stop();
    if (this.user) {
      try {
        let user = await this.$store.dispatch("getUserById", this.user._id);

        try {
          let userEndpoint = await this.$store.dispatch(
            "getEndpointByDeviceType",
            this.user._id
          );
          if (userEndpoint && userEndpoint._id) {
            user.endpoint = userEndpoint;
          }
        } catch (e) {
          console.log(e);
        }

        localStorage.user = JSON.stringify(user);
        console.log(this.user.endpoint);
      } catch (e) {
        console.log(e);
      }

      // await this.init();

      if (that.FCMpayload) {
        /*         if (
          that.FCMpayload.type == "callNotification" &&
          that.FCMpayload.appointmentId
        ) {
          that.onCallPushNotification(that.FCMpayload);
          that.$store.state.FCMpayload = null;
        } */
      }

      //Configure location background service
      /*       if (
        this.locationTrackingEnabled &&
        this.careGroupDetails &&
        this.careGroupDetails.locationTracking &&
        this.careGroupDetails.locationTracking.basicAuth &&
        this.careGroupDetails.locationTracking.basicAuth.username &&
        this.careGroupDetails.locationTracking.basicAuth.password
      )  */
      try {
        BackgroundGeolocation.configure({
          locationProvider: BackgroundGeolocation.ACTIVITY_PROVIDER,
          desiredAccuracy: BackgroundGeolocation.HIGH_ACCURACY,
          stationaryRadius: 5,
          distanceFilter: 5,
          notificationTitle: this.$t("message.Tracking location"),
          notificationText: this.$t("message.Enabled"),
          debug: false,
          interval: 1000,
          fastestInterval: 1000,
          activitiesInterval: 10000,
          stopOnTerminate: false,
          startOnBoot: true,
          startForeground: true,
          maxLocations: 1000,
        });

        BackgroundGeolocation.removeAllListeners();

        BackgroundGeolocation.on("location", async function (location) {
          //console.log("location", location);
          BackgroundGeolocation.startTask(async function (taskKey) {
            await that.$store.dispatch("saveLocationUpdatesForAmbulance", {
              lat: location.latitude,
              lon: location.longitude,
              tenantId: that.user.tenant._id,
              userId: that.user.endpoint._id,
              deviceId: localStorage.deviceId,
            });

            BackgroundGeolocation.endTask(taskKey);
          });

          await that.$store.dispatch("getCurrentLocation", {
            latitude: location.latitude,
            longitude: location.longitude,
            locale: that.$i18n.locale,
          });
        });

        BackgroundGeolocation.on(
          "stationary",
          async function (stationaryLocation) {
            console.log("stationary", stationaryLocation);

            await that.$store.dispatch("saveLocationUpdatesForAmbulance", {
              tenantId: that.user.tenant._id,
              userId: that.user.endpoint._id,
              deviceId: localStorage.deviceId,
            });

            await that.$store.dispatch("getCurrentLocation", {
              latitude: stationaryLocation.latitude,
              longitude: stationaryLocation.longitude,
              locale: that.$i18n.locale,
            });
          }
        );

        BackgroundGeolocation.on("error", function (error) {
          console.log(
            "[ERROR] BackgroundGeolocation error:",
            error.code,
            error.message
          );
        });

        BackgroundGeolocation.on("start", function () {
          console.log("[INFO] BackgroundGeolocation service has been started");
        });

        BackgroundGeolocation.on("stop", function () {
          console.log("[INFO] BackgroundGeolocation service has been stopped");
        });

        BackgroundGeolocation.on("authorization", function (status) {
          console.log(
            "[INFO] BackgroundGeolocation authorization status: " + status
          );
          if (status !== BackgroundGeolocation.AUTHORIZED) {
            // we need to set delay or otherwise alert may not be shown
            setTimeout(function () {
              var showSettings = confirm(
                "App requires location tracking permission. Would you like to open app settings?"
              );
              if (showSettings) {
                return BackgroundGeolocation.showAppSettings();
              }
            }, 1000);
          }
        });

        BackgroundGeolocation.on("background", function () {
          console.log("[INFO] App is in background");
        });

        BackgroundGeolocation.on("foreground", function () {
          console.log("[INFO] App is in foreground");
        });

        BackgroundGeolocation.on("abort_requested", function () {
          console.log("[INFO] Server responded with 285 Updates Not Required");

          // Here we can decide whether we want stop the updates or not.
          // If you've configured the server to return 285, then it means the server does not require further update.
          // So the normal thing to do here would be to `BackgroundGeolocation.stop()`.
          // But you might be counting on it to receive location updates in the UI, so you could just reconfigure and set `url` to null.
        });

        BackgroundGeolocation.on("http_authorization", () => {
          console.log("[INFO] App needs to authorize the http requests");
        });

        this.handleLocationtracking();
      } catch (e) {
        console.eror("Error in ititializing location tracking service", e);
      }

      //Adding wait to show loader
      await setTimeout(() => {
        if (this.careGroupDetails) {
          this.CARECARDS_LOADED = true;
        }
      }, 2000);

      setTimeout(() => {
        if (that.messages) {
          that.$store.state.message = that.selectedMessage = that.messages[0];
        }
      }, 2000);

      await this.$store.dispatch("getSettings");
      /*       if (this.user.endpoint.obd2Data) {
        this.obd2Data = this.user.endpoint.obd2Data;
        this.getMinutesAgo();
        this.lastObd2UpdatedMinuteInterval = setInterval(() => {
          that.getMinutesAgo();
        }, 60000);
      } */

      await this.getAmbulanceRequest();

      //Socket listeners
      socket.on("ambulanceRequested", () => {
        this.getAmbulanceRequest();
      });

      socket.on("newMessage", async (data) => {
        if (data.toUser == that.user._id) {
          this.getMessages();
          that.$refs["message-badge"].$el.style.display = "inline-block";
          that.unreadChatList.push(data.messageId);
        }
      });

      this.initSocket();
      window.initSocket = this.initSocket;

      socket.on("newChatMessage", async (message) => {
        console.log("newChatMessage--", message);
        if (message.chatMessage.username != this.user.username) {
          if (
            message.chatMessage.status &&
            message.chatMessage.status == "initiated"
          ) {
            this.remoteUser = message.chatMessage.from;
            this.caller.name = this.remoteUser.name;
            this.caller.img = avatarImage;
            this.callNotification = true;
          } else if (
            message.chatMessage.status &&
            message.chatMessage.status == "ended"
          ) {
            if (this.$refs.vmaatu) {
              this.$refs.vmaatu.destroy();
            }
            this.showVideo = false;
            this.$store.commit("setState", {
              stateName: "homePageActiveTab",
              stateValue: "home",
            });
          } else if (
            message.chatMessage.status &&
            message.chatMessage.status == "cancelled"
          ) {
            this.callNotification = false;
          } else if (
            message.chatMessage.status &&
            message.chatMessage.status == "missed"
          ) {
            this.callNotification = false;
          }

          let response = await this.$store.dispatch(
            "getAmbulanceRequestById",
            this.ambulanceRequest._id
          );
          if (response && response._id) {
            this.ambulanceRequest = response;
          }
        }
      });

      //Subscribing to firebase topics
      // let instance = this.baseUrl
      //   .split("//")[1]
      //   .split(":")[0]
      //   .replace(/\./g, "_");

      /*       cordova.plugins.firebase.messaging.onMessage(function (payload) {
        console.log("New foreground FCM message: ", payload);
        if (
          payload.type &&
          payload.type == "callNotification" &&
          payload.ambulanceRequestId
        ) {
          this.getAmbulanceRequest();
        } else {
          if (!this.ambulanceRequest) {
            this.getAmbulanceRequest();
          }
        }
      }); */

      cordova.plugins.firebase.messaging.onBackgroundMessage(function (
        payload
      ) {
        console.log("New background FCM message: ", payload);
        that.getAmbulanceRequest();
      });
      cordova.plugins.firebase.messaging.onMessage(function (payload) {
        console.log("New foreground FCM message: ", payload);
        that.getAmbulanceRequest();
      });
    } else {
      console.log("no user");
      this.$router.push({ path: "/signin" });
    }
  },

  beforeDestroy() {
    this.$root.onBackButton = null;
    socket.off("appointmentReviewed");
    socket.off("appointmentRequestAttended");
    socket.off("appointmentDeclined");
    socket.off("newMessage");
    socket.off("nurseCallingUpdate");
    window.initSocket = null;
    clearInterval(this.btIntervalWriter);
    clearInterval(this.lastObd2UpdatedMinuteInterval);
  },
};
</script>

<style scoped>
/* #home {
      margin-top: 1em;
  } */
#home .stats {
  text-align: center;
}
.search-block {
  background-color: white;
  padding-top: 1em;
  padding-right: 2em;
  padding-left: 2em;
  margin-left: -2em;
  margin-right: -2em;
  padding-bottom: 6px;
}
.not-found-img {
  width: 100%;
}
.card-header-nav {
  background: var(--color-primary);
}
.card-header-nav .nav-pills > li > a > div {
  color: #fff;
}
.card-header-nav .nav-pills.nav-pills-neutral .nav-item .nav-link {
  background-color: transparent !important;
  box-shadow: none;
}

/* .nav-link {
  color: grey !important;
} */
#home .tab-content.tab-subcategories {
  width: 100%;
}
.main-panel > .content {
  margin-top: 0px;
}
.nav-pills.nav-pills:not(.flex-column) .nav-item:not(:last-child) .nav-link {
  margin-right: 8px;
}
.icon .nav-link {
  padding: 0px 15px !important;
}
.tab-no-space {
  padding-top: 0px !important;
}
</style>

<style scoped>
.ambulance-image {
  transform: translateX(-52%);
  position: fixed;
  height: auto;
  width: 100%;
  max-height: 72%;
  margin-top: 4%;
}
[dir="rtl"] .ambulance-image {
  transform: translateX(52%);
}
.video-call-wrapper {
  width: 100%;
  position: absolute;
  top: 0px;
  bottom: 0px;
  inset-inline-end: 0px;
  height: 93vh;
  z-index: 1030;
  background-color: #f1f1f1;
}

.fullscreen-window {
  width: 100%;
  top: 7vh;
  bottom: 0px;
  inset-inline-end: 0px;
  height: calc(100vh - 130px);
  background-color: #f1f1f1;
  overflow: hidden;
}

.end-button {
  position: absolute;
  bottom: 10.5em;
  inset-inline-end: 45%;
  transform: translateX(50%);
  z-index: 2022;
}
[dir="rtl"] .end-button {
  transform: translateX(-50%);
}
.ios .video-call-wrapper {
  height: calc(100vh - 123px);
}

/deep/ .nav-pills .nav-item .nav-link {
  min-width: 64px;
}
#care-card-front,
.care-card-description {
  height: 18em;
}
.care-card-description {
  overflow: scroll;
}
.image-text-overlay {
  font-size: 0.7em;
}
.appointments-wrapper {
  margin-top: 1em;
}
.icon.icon-circle {
  width: 65px;
  height: 65px;
  max-width: 65px;
  margin: auto;
  margin-top: 8px;
  border-radius: 30%;
}
.icon.icon-circle i {
  display: table;
  margin: 0 auto;
  line-height: 2.8;
  font-size: 25px;
}
.link-label {
  margin-top: 1em;
  display: block;
}
.link-section {
  margin-top: 0.5em;
  padding-top: 1.5em;
  border-top: 1px solid #dcd7d7;
}
/* /deep/ .tab-content {
  margin-top: 1em;
} */
/deep/ .tab-content {
  height: calc(100% - 68px);
}
.content > div,
.content > div > div {
  height: 100%;
}
.tab-pane.active {
  height: 100%;
  overflow: scroll;
  /* padding-top: 1em; */
}
.message-list {
  padding-bottom: 0.5em;
  padding-top: 0.5em;
  border-top: 1px solid #d6d0d0;
}
.message-list:first-child {
  border-top: none;
}
.message-list.selected {
  background-color: whitesmoke;
}
.message-icon {
  line-height: 3em;
  color: #2ca8ff;
  font-size: 1.5em;
}
.reason {
  font-size: 1.3em;
  margin-bottom: 2px;
}
.icon.icon-circle img {
  padding: 20px;
}
/deep/ .sc-chat-window {
  max-height: 100%;
  inset-inline-end: 0px;
  bottom: 0px;
  width: 100%;
  height: 78vh;
}
/deep/ .sc-message {
  width: 90%;
}
/deep/ .sc-header {
  display: none;
}
/deep/ .sc-launcher.opened {
  display: none;
}

/deep/ .VueCarousel-dot-container {
  margin-top: 0px !important;
}
/deep/ .VueCarousel-dot {
  width: 5px !important;
  height: 5px !important;
  margin-top: 0px !important;
}
/deep/ .VueCarousel-dot:focus {
  outline: none !important;
}

.boxes {
  --size: 32px;
  --duration: 800ms;
  height: calc(var(--size) * 2);
  width: calc(var(--size) * 3);
  position: relative;
  transform-style: preserve-3d;
  transform-origin: 50% 50%;
  margin-top: calc(var(--size) * 1.5 * -1);
  transform: rotateX(60deg) rotateZ(45deg) rotateY(0deg) translateZ(0px);
}
.boxes .box {
  width: var(--size);
  height: var(--size);
  top: 0;
  left: 0;
  position: absolute;
  transform-style: preserve-3d;
}
.boxes .box:nth-child(1) {
  transform: translate(100%, 0);
  animation: box1 var(--duration) linear infinite;
}
.boxes .box:nth-child(2) {
  transform: translate(0, 100%);
  animation: box2 var(--duration) linear infinite;
}
.boxes .box:nth-child(3) {
  transform: translate(100%, 100%);
  animation: box3 var(--duration) linear infinite;
}
.boxes .box:nth-child(4) {
  transform: translate(200%, 0);
  animation: box4 var(--duration) linear infinite;
}
.boxes .box > div {
  --background: #45b2fe;
  --top: auto;
  --inset-inline-end: auto;
  --bottom: auto;
  --left: auto;
  --translateZ: calc(var(--size) / 2);
  --rotateY: 0deg;
  --rotateX: 0deg;
  position: absolute;
  width: 100%;
  height: 100%;
  background: var(--background);
  top: var(--top);
  inset-inline-end: var(--right);
  bottom: var(--bottom);
  left: var(--left);
  transform: rotateY(var(--rotateY)) rotateX(var(--rotateX))
    translateZ(var(--translateZ));
}
.boxes .box > div:nth-child(1) {
  --top: 0;
  --left: 0;
}
.boxes .box > div:nth-child(2) {
  --background: #369ae0;
  --inset-inline-end: 0;
  --rotateY: 90deg;
}
.boxes .box > div:nth-child(3) {
  --background: #aadcff;
  --rotateX: -90deg;
}
.boxes .box > div:nth-child(4) {
  --background: #dbe3f4;
  --top: 0;
  --left: 0;
  --translateZ: calc(var(--size) * 3 * -1);
}
@keyframes box1 {
  0%,
  50% {
    transform: translate(100%, 0);
  }
  100% {
    transform: translate(200%, 0);
  }
}
@keyframes box2 {
  0% {
    transform: translate(0, 100%);
  }
  50% {
    transform: translate(0, 0);
  }
  100% {
    transform: translate(100%, 0);
  }
}
@keyframes box3 {
  0%,
  50% {
    transform: translate(100%, 100%);
  }
  100% {
    transform: translate(0, 100%);
  }
}
@keyframes box4 {
  0% {
    transform: translate(200%, 0);
  }
  50% {
    transform: translate(200%, 100%);
  }
  100% {
    transform: translate(100%, 100%);
  }
}
html {
  -webkit-font-smoothing: antialiased;
}
* {
  box-sizing: border-box;
}
*:before,
*:after {
  box-sizing: border-box;
}
body {
  min-height: 100vh;
  font-family: Roboto, Arial;
  color: #adafb6;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #f9fbff;
}
body .dribbble {
  position: fixed;
  display: block;
  inset-inline-end: 20px;
  bottom: 20px;
}
body .dribbble img {
  display: block;
  height: 28px;
}

@media (min-width: 768px) {
  #care-card-front,
  .care-card-description {
    height: 24em;
  }
}

@media (min-width: 992px) {
  #care-card-front,
  .care-card-description {
    height: 22em;
  }
}

@media (max-height: 667px) {
  #care-card-front,
  .care-card-description {
    height: 11em;
  }
}

@media (min-height: 768px) {
  /deep/ .sc-chat-window {
    height: 74vh;
  }
}

@media (min-height: 1024px) {
  /deep/ .sc-chat-window {
    height: 81vh;
  }
}

.la-ball-scale-multiple,
.la-ball-scale-multiple > div {
  position: relative;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
}
.la-ball-scale-multiple {
  display: block;
  font-size: 0;
  color: #fff;
}
.la-ball-scale-multiple.la-dark {
  color: #333;
}
.la-ball-scale-multiple > div {
  display: inline-block;
  float: none;
  background-color: currentColor;
  border: 0 solid currentColor;
}
.la-ball-scale-multiple {
  width: 32px;
  height: 32px;
}
.la-ball-scale-multiple > div {
  position: absolute;
  top: 0;
  left: 0;
  width: 32px;
  height: 32px;
  border-radius: 100%;
  opacity: 0;
  -webkit-animation: ball-scale-multiple 1s 0s linear infinite;
  -moz-animation: ball-scale-multiple 1s 0s linear infinite;
  -o-animation: ball-scale-multiple 1s 0s linear infinite;
  animation: ball-scale-multiple 1s 0s linear infinite;
}
.la-ball-scale-multiple > div:nth-child(2) {
  -webkit-animation-delay: 0.2s;
  -moz-animation-delay: 0.2s;
  -o-animation-delay: 0.2s;
  animation-delay: 0.2s;
}
.la-ball-scale-multiple > div:nth-child(3) {
  -webkit-animation-delay: 0.4s;
  -moz-animation-delay: 0.4s;
  -o-animation-delay: 0.4s;
  animation-delay: 0.4s;
}
.la-ball-scale-multiple.la-sm {
  width: 16px;
  height: 16px;
}
.la-ball-scale-multiple.la-sm > div {
  width: 16px;
  height: 16px;
}
.la-ball-scale-multiple.la-2x {
  width: 64px;
  height: 64px;
}
.la-ball-scale-multiple.la-2x > div {
  width: 64px;
  height: 64px;
}
.la-ball-scale-multiple.la-3x {
  width: 96px;
  height: 96px;
}
.la-ball-scale-multiple.la-3x > div {
  width: 96px;
  height: 96px;
}
/*
 * Animation
 */
@-webkit-keyframes ball-scale-multiple {
  0% {
    opacity: 0;
    -webkit-transform: scale(0);
    transform: scale(0);
  }
  5% {
    opacity: 0.75;
  }
  100% {
    opacity: 0;
    -webkit-transform: scale(1);
    transform: scale(1);
  }
}
@-moz-keyframes ball-scale-multiple {
  0% {
    opacity: 0;
    -moz-transform: scale(0);
    transform: scale(0);
  }
  5% {
    opacity: 0.75;
  }
  100% {
    opacity: 0;
    -moz-transform: scale(1);
    transform: scale(1);
  }
}
@-o-keyframes ball-scale-multiple {
  0% {
    opacity: 0;
    -o-transform: scale(0);
    transform: scale(0);
  }
  5% {
    opacity: 0.75;
  }
  100% {
    opacity: 0;
    -o-transform: scale(1);
    transform: scale(1);
  }
}
@keyframes ball-scale-multiple {
  0% {
    opacity: 0;
    -webkit-transform: scale(0);
    -moz-transform: scale(0);
    -o-transform: scale(0);
    transform: scale(0);
  }
  5% {
    opacity: 0.75;
  }
  100% {
    opacity: 0;
    -webkit-transform: scale(1);
    -moz-transform: scale(1);
    -o-transform: scale(1);
    transform: scale(1);
  }
}
</style>
